(function () {
  "use strict";
  var doc = document;
  function hydrate(scope) {
    var root = scope && scope.querySelectorAll ? scope : doc;
    var forms = root.querySelectorAll("[data-xg-sms]");
    for (var i = 0; i < forms.length; i += 1) {
      var wrap = forms[i];
      if (wrap.hasAttribute("data-xg-sms-ready")) continue;
      var template = wrap.querySelector("[data-xg-sms-phone]");
      var mount = wrap.querySelector("[data-xg-sms-mount]");
      if (!template || !mount) continue;
      mount.appendChild(template.content.cloneNode(true));
      wrap.setAttribute("data-xg-sms-ready", "");
    }
  }
  function parts(node) {
    var wrap = node.closest && node.closest("[data-xg-sms]");
    if (!wrap) return null;
    var form = wrap.querySelector("form");
    if (!form) return null;
    return {
      form: form,
      phone: form.querySelector("[data-xg-sms-number]"),
      consent: form.querySelector("[data-xg-sms-consent]")
    };
  }
  function digits(value) {
    return String(value || "").replace(/\D/g, "");
  }
  doc.addEventListener("input", function (event) {
    var p = parts(event.target);
    if (!p || !p.phone || !p.consent) return;
    p.consent.required = p.phone.value.trim() !== "";
    if (p.consent.checked || !p.consent.required) p.consent.setCustomValidity("");
  });
  doc.addEventListener("change", function (event) {
    var p = parts(event.target);
    if (!p || !p.consent) return;
    if (p.consent.checked) p.consent.setCustomValidity("");
  });
  doc.addEventListener("submit", function (event) {
    var p = parts(event.target);
    if (!p || event.target !== p.form) return;
    if (!p.phone || !p.consent) return;
    if (digits(p.phone.value) && !p.consent.checked) {
      p.consent.required = true;
      p.consent.setCustomValidity(
        "Tick the box to get texts, or clear the number to sign up by email only."
      );
      p.consent.reportValidity();
      event.preventDefault();
      return;
    }
    if (!digits(p.phone.value)) {
      p.phone.disabled = true;
      p.consent.disabled = true;
    }
  });
  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", function () {
      hydrate(doc);
    });
  } else {
    hydrate(doc);
  }
  doc.addEventListener("shopify:section:load", function (event) {
    hydrate(event.target || doc);
  });
})();
